var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.$root.listItemClasses,attrs:{"to":{
    name: 'purchase',
    params: {
      purchaseId: _vm.purchase.id
    }
  }}},[_vm._v("\n  "+_vm._s(_vm.$root.displayDateTimeFmt(_vm.purchase.purchased_at))+":\n  "+_vm._s(_vm.purchase.purchasable_items.map(function (pi) { return pi.attributes.name; }).join(", "))+"\n  "+_vm._s(_vm.purchase.gift ? _vm.$root.giftIcon : '')+"\n  "),(_vm.showBuyer)?_c('span',[_vm._v("\n    ("+_vm._s(_vm.purchase.customer_email)+")\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84589236","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseListItem.vue
// module id = 1242
// module chunks = 1